import { createAsyncThunk } from "@reduxjs/toolkit";
import { cloudChiprApi } from "../../../../services/cloudchipr.api";
import { getBillingExplorerDimensionGroupingsThunk } from "@/store/resource-explorer/thunks/common/getBillingExplorerDimensionGroupingsThunk";

interface GetResourceExplorerPossibleGroupingsThunkArgs {
  enableCategoryGroupingFilterV2: boolean;
}
export const getResourceExplorerPossibleGroupingsThunk = createAsyncThunk(
  "resourceExplorer/getResourceExplorerPossibleGroupings",
  async (
    {
      enableCategoryGroupingFilterV2,
    }: GetResourceExplorerPossibleGroupingsThunkArgs,
    { dispatch },
  ) => {
    const { getUsersMeOrganisationsCurrentResourceExplorerPossibleGroupings } =
      cloudChiprApi.endpoints;

    try {
      const possibleGroupingsPromise = dispatch(
        getUsersMeOrganisationsCurrentResourceExplorerPossibleGroupings.initiate(),
      ).unwrap();

      const dimensionGroupingsPromise = dispatch(
        getBillingExplorerDimensionGroupingsThunk({
          enableCategoryGroupingFilterV2,
        }),
      ).unwrap();
      await Promise.all([possibleGroupingsPromise, dimensionGroupingsPromise]);
    } catch (e) {
      return null;
    }
  },
);
